import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../../context/LoginContext/AuthContext";

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [role, setRole] = useState(null); // Change initial state to null
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (authLoading) {
      setIsLoading(true); // If auth is loading, role should also be loading
    } else if (user) {
      setRole(user?.role || user?.user?.role || "");
      setIsLoading(false);
    } else {
      setRole(null); // Reset role if user logs out
      setIsLoading(false);
    }
  }, [user, authLoading]);

  return (
    <RoleContext.Provider value={{ role, setRole, isLoading }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
